
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrenamientos/official-scrum-trainer-certification-training",
      function () {
        return require("private-next-pages/entrenamientos/official-scrum-trainer-certification-training.js");
      }
    ]);
  